export const formatPrice = (price?: number) => {
  if (!price) return;
  const formatting = new Intl.NumberFormat("en-SG", {
    style: "currency",
    currency: "SGD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formatting.format(price);
};

export const formatDiscount = (
  percent?: number,
  havePrefix?: boolean,
  haveSuffix?: boolean,
) => {
  return (
    percent &&
    `${havePrefix ? "-" : ""}${percent}%${haveSuffix ? "\u00a0off" : ""}`
  );
};
